module.exports = __webpack_public_path__ + "static/img/close.d8f3e884.svg";